<template>
  <div class="ClassSetBox">
    <template v-if="$route.name == 'classSet'">
      <ots-main-title :mainTopBtn="mainTopBtnList" :isShowSearchIcon="false">
        <template v-slot:tabs>
          <div>
            <span class="f20 col_black">考试批次：<span>{{ planInfo.name }}</span></span>
          </div>
        </template>
      </ots-main-title>
      <ots-custom-dialog :dialog.sync="addDialog" title="自动安排" width="43%">
        <template v-slot:content>
          <h3>排序设置</h3>
          <div class="courseFlag">
            <span>报考相同科目考生安排在同一考场</span>
            <el-switch
              v-model="courseFlag"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
            <span>说明：开启后报考相同科目考生尽可能安排在同一考场</span>
          </div>
          <h3 class="classFlag">考场安排策略选择</h3>
          <el-radio-group v-model="classFlag">
            <div class="classFlagslass">
              <el-radio label="1"
                >策略1<span class="illustration">按考点容量大小依次安排（优先容量最接近考场，实现考场最大化利用）</span></el-radio
              >
            </div>
            <div class="classFlagslass1">
              <el-radio label="2"
                >策略2<span class="illustration"> 混排（各考场依次安排，尽量平均分配）</span>   </el-radio
              >
            </div>
          </el-radio-group>
        </template>
        <template v-slot:footer>
          <el-button round @click="addDialog = false">取消</el-button>
          <el-button round type="primary" @click="addSchool">确定</el-button>
        </template>
      </ots-custom-dialog>

      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        :batchOperBtn="batchOperBtn"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>

      <!-- 批量补时 -->
      <ots-custom-dialog :dialog.sync="suppleTimeDialog" title="批量补时" width="780px" class="SuppleClass">
        <template v-slot:content>
          <div style="margin-top: -21px;">
            <h4 style="text-align: center; color: #606266;">{{ planInfo.name + '-' + SuppleInfo.name }}</h4>
          </div>
          <div class="msgBox">
            <span>考生范围</span>
            <div class="formStyle">
              <el-form ref="form" :model="SuppleForm" label-width="80px">
                <el-form-item label="考点">
                  <el-select v-model="SuppleForm.placeId" placeholder="请选择考点">
                      <el-option :label="item.name" :value="item.id" v-for="item in siteList" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教室">
                  <el-select v-model="SuppleForm.classId" placeholder="请选择教室">
                      <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="考试课程">
                  <el-select v-model="SuppleForm.courseId" placeholder="请选择考试课程">
                    <el-option :label="item.courseName" :value="item.courseId" v-for="item in courseList" :key="item.courseId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="关键字" v-if="false">
                  <el-input v-model="SuppleForm.searchKey" placeholder=""></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="msgBox" style="margin-top: 8px;">
            <span style="display: inline">补时方案 <span style="color: red;">*</span></span>
            <div class="formStyle">
              <el-form ref="form" :model="SuppleForm" label-width="80px">
                <el-form-item label="在" style="width: 100%; display: flex;">
                  <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" v-model="SuppleForm.beginExamTime" style="width: 100%;"></el-date-picker>
                  <span style="position: absolute; width: 240px;line-height: 36px; margin-left: 16px;">
                    之前开始答卷的考生&nbsp;&nbsp;
                    <el-tooltip class="item" effect="dark" content="该设置可将迟到的考生排除在不补时范围之外。" placement="top">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </span>
                </el-form-item>
                <el-form-item label="补时">
                  <el-input type="number" placeholder="请输入补时时间" v-model.number="SuppleForm.minutes" class="numrule" :min="1"></el-input>
                  <span style="position: absolute; width: 240px;line-height: 36px; margin-left: 16px;">分钟</span>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="check">
            <el-button type="primary" plain @click="inspectorNumber">核查人数范围</el-button>
          </div>
          <div class="msgBox" v-if="isInspector">
            <div class="formStyle" style="height: auto; padding-bottom: 16px;">
              <div>
                <span style="width: auto;">考生=</span>
                <el-button type="primary" plain style="padding: 4px 20px;" v-if="!SuppleForm.placeId && !SuppleForm.classId && !SuppleForm.courseId && !SuppleForm.searchKey">所有人</el-button>
                <el-button type="primary" plain style="padding: 4px 20px;" v-else>
                  {{ SuppleForm.placeId ? placeName: '全部考点' }}，
                  {{ SuppleForm.classId ? className: '全部教室' }}，
                  {{ SuppleForm.courseId ? courseName: '全部课程' }}
                  {{ SuppleForm.searchKey ? '，' + SuppleForm.searchKey + '相关' : ''}}
                </el-button>
                <span>，答卷时间早于</span>
                <el-button type="primary" plain style="padding: 4px 20px;">{{ SuppleForm.beginExamTime }}</el-button>
              </div>
              <div style="margin-top: 8px;">
                <span style="width: auto;">
                  满足该条件正在答卷的考生有
                  <span style="margin: 0 4px; color: #fe5958; width: auto; font-weight: 700;">
                  {{ studentCountNumber }}
                  </span>
                  人
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="suppleTimeDialog = false">取消</el-button>
          <el-button round type="primary" @click="addSupple">确定</el-button>
        </template>
      </ots-custom-dialog>


      <ots-custom-dialog :dialog.sync="ImportClassDialog" title="导入考场安排结果">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span
                  style="color: #006aff"
                  @click="$getStaticFile('考场安排结果导入模板.xlsx')"
                  class="cp"
                >
                  <i class="el-icon-download"></i>
                  下载考场安排结果导入模板
                </span>
              </el-form-item>
              <el-form-item v-model="importForm.Filedata">
                <ots-upload-file
                  :httpRequest="handleFormData"
                  fileType="xlsx"
                />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>
                  2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="ImportClassDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>

      <ots-custom-dialog :dialog.sync="entranceRuleSetDialog" title="准考证号的自定义规则设置" width="60%">
        <template v-slot:content>
          <el-tabs v-model="entranceRuleActiveTab">
            <!-- 默认规则 -->
            <el-tab-pane label="默认规则" name="default">
              <h4 class="custom-section-title">规则说明</h4>
              <div class="default-rule-list">
                <div class="default-rule-item" :class="['bg-blue', 'bg-orange', 'bg-green'][index]" v-for="(item, index) in systemDefaultRules" :key="index">
                  {{ item.value }}
                </div>
              </div>
              <div class="default-rule-remark">
                批次下所有学生统一使用：{{ systemDefaultRules.map(item => item.value).join(' + ') }}
              </div>
            </el-tab-pane>

            <!-- 自定义规则 -->
            <el-tab-pane label="自定义规则" name="custom">
              <!-- 通用规则 -->
              <fieldset class="custom-fieldset">
                <legend class="custom-legend">通用规则</legend>
                <div class="custom-rule-row">
                  <span class="rule-example">示例：{{ generateExample(generalRule) }}</span>
                  <el-form :inline="true" :model="generalRule" label-width="100px" class="custom-rule-form">
                    <el-form-item label="自定义前缀">
                      <el-input v-model="generalRule.customPrefix" placeholder="请输入前缀" @keyup.native="generalRule.customPrefix = generalRule.customPrefix.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"></el-input>
                    </el-form-item>
                    <el-form-item label="流水号位数">
                      <el-select v-model="generalRule.numberLen" placeholder="请选择">
                        <el-option label="4位" :value="4"></el-option>
                        <el-option label="5位" :value="5"></el-option>
                        <el-option label="6位" :value="6"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="流水号起始号">
                      <el-input v-model.number="generalRule.numberStart" placeholder="请输入起始号" type="number" :min="1"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </fieldset>

              <!-- 按专业设置 -->
              <fieldset class="custom-fieldset" v-if="subjectList.length > 0">
                <legend class="custom-legend">按专业设置</legend>
                <el-collapse v-model="expandedSubjects" style="border: 0px ;">
                  <el-collapse-item v-for="subject in subjectList" :key="subject.id" :name="subject.id">
                    <template slot="title">
                      <span class="subject-title">{{ subject.name }}</span>
                      <span class="subject-example" v-if="getSubjectRule(subject.id)">示例：{{ generateExample(getSubjectRule(subject.id)) }}</span>
                    </template>
                    <el-form :inline="true" :model="getSubjectRule(subject.id)" label-width="100px" class="custom-rule-form" v-if="getSubjectRule(subject.id)">
                      <el-form-item label="自定义前缀">
                        <el-input v-model="getSubjectRule(subject.id).customPrefix" placeholder="请输入前缀" @keyup.native="getSubjectRule(subject.id).customPrefix = getSubjectRule(subject.id).customPrefix.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"></el-input>
                      </el-form-item>
                      <el-form-item label="流水号位数">
                        <el-select v-model="getSubjectRule(subject.id).numberLen" placeholder="请选择">
                          <el-option label="4位" :value="4"></el-option>
                          <el-option label="5位" :value="5"></el-option>
                          <el-option label="6位" :value="6"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="流水号起始号">
                        <el-input v-model.number="getSubjectRule(subject.id).numberStart" placeholder="请输入起始号" type="number" :min="1"></el-input>
                      </el-form-item>
                    </el-form>
                  </el-collapse-item>
                </el-collapse>
              </fieldset>
            </el-tab-pane>

            <!-- 直接导入 -->
            <el-tab-pane label="直接导入" name="import">
              <div class="import-section">
                <div class="import-row">
                  <span class="import-label">1.模板下载：</span>
                  <el-button type="text" @click="downloadEntranceTemplate">
                    <i class="el-icon-download"></i> 下载导入模板
                  </el-button>
                </div>
                <div class="import-row">
                  <span class="import-label">2.文件导入：</span>
                  <ots-upload-file :httpRequest="handleEntranceImportFile" fileType="xlsx" />
                </div>
                <div class="import-row" style="margin-top: 16px;" v-if="entranceImportFile">
                  <el-button type="primary" plain @click="doEntranceImport">导入</el-button>
                </div>
                <div class="import-data-list" style="border-top: #d3d3d3 1px solid ; margin-top: 10px; padding-top: 16px;" v-if="entranceImportData.length > 0">
                  <h4 class="custom-section-title">已导入的准考证号</h4>
                  <el-table :data="entranceImportData" border style="width: 100%">
                    <el-table-column prop="cardNo" label="证件号"></el-table-column>
                    <el-table-column prop="code" label="准考证号"></el-table-column>
                  </el-table>
                  <el-pagination
                    style="margin-top: 12px; text-align: right;"
                    @current-change="handleEntranceImportPageChange"
                    :current-page="entranceImportPagination.page"
                    :page-size="entranceImportPagination.size"
                    layout="total, prev, pager, next"
                    :total="entranceImportPagination.total">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
        <template v-slot:footer>
          <el-button round @click="entranceRuleSetDialog = false">取消</el-button>
          <el-button round type="primary" @click="saveEntranceRuleSet" v-if="entranceRuleActiveTab === 'custom'">保存</el-button>
        </template>
      </ots-custom-dialog>

      <ots-custom-dialog :dialog.sync="entranceCodeDialog" title="准考证号设置规则">
        <template v-slot:content>
          <el-form :model="entranceCodeForm">
            <el-form-item label="准考证生成规则">
              <el-radio-group v-model="entranceCodeForm.entranceRule">
                  <el-radio-button :label=1>系统默认规则</el-radio-button>
                  <el-radio-button :label=2>自定义规则</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div v-if="entranceCodeForm.entranceRule === 1">
              <el-form-item label="系统默认规则">
                <el-input v-model="entranceCodeForm.defaultRule" disabled></el-input>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="自定义前缀">
                <el-input 
                  v-model="entranceCodeForm.preCode"
                  placeholder="请输入自定义前缀"
                  @keyup.native="handlePreCodeInput"
                  @compositionstart.native="handleCompositionStart"
                  @compositionend.native="handleCompositionEnd"
                >
              </el-input>
              </el-form-item>
              <el-form-item label="自定义流水位数">
                <el-select v-model="entranceCodeForm.rndNumber" placeholder="请选择自定义流水位数">
                  <el-option label="4位" :value="4"></el-option>
                  <el-option label="5位" :value="5"></el-option>
                  <el-option label="6位" :value="6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="自定义流水起始号">
                <el-input v-model="entranceCodeForm.startNumber" placeholder="流水起始号，例如：100"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </template>
        <template v-slot:footer>
          <el-button round @click="entranceCodeDialog = false">取消</el-button>
          <el-button round type="primary" @click="entranceCodeDialogSubmit">提交</el-button>
        </template>
      </ots-custom-dialog>

    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanSite, getCourseListBySessionList, addTimeStudentCountAPI, addTimeBatchAPI } from "@/http/modules/examSet/section";
import { 
  getClassListFn, downloadPreGeneratedAnswerPaperAPI, setStudentClassFn, 
  publishPlanClassFn, openSignTable, exportClassRoom, getPreGeneratedAnswerPaperAPI, 
  judgeImportArrangeClassInfoAPI, importArrangeClassInfoAPI,exportStudentFn,exportEntranceFn ,  
  getSubjectListByPlanIdAPI,  getSystemDefaultRuleAPI,  getCustomRuleByPlanIdAPI,
  saveCustomRuleByPlanIdAPI,  entranceExportTemplateAPI,  entranceImportAPI,entranceImportDataListAPI
} from "@/http/modules/examSet/planClass";
import { fn } from "moment/moment";

export default {
  name: "classSet",
  data() {
    return {
      addDialog: false,
      currentPlanName: "",
      needSignTable: false,
      activeName: "curentPlan",
      classForm: {
        planId: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试场次",
          prop: "name",
        },
        {
          title: "考试开始时间",
          prop: "beginTime"
        },
        {
          title: "考试结束时间",
          prop: "endTime"
        },
        {
          title: "考试课程",
          prop: "courseNames",
        },
        {
          title: "考点",
          prop: "placeNames",
        },
        {
          title: "已安排",
          type: "button",
          prop: "studentCount",
          disableFn: (val) => (val.row.studentCount > 0 ? false : true),
          click: this.checkStudent,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "批量补时",
              formatter: (scope) => {
                const { beginTime, endTime } = scope.row
                let begin = Date.parse(new Date(beginTime).toString())
                let end = Date.parse(new Date(endTime).toString())
                let current = Date.now()
                if (begin < current && current < end) {
                  return false
                } else {
                  return true
                }
              },
              click: this.Click_Batch_Supple_Time,
            },
          ],
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      planInfo: {},
      isUseYy: 0,
      courseFlag: 1,
      classFlag: "1",
      // 批量补时相关
      suppleTimeDialog: false,
      SuppleNumber: 0,
      SuppleInfo: {},
      SuppleForm: {
        planId: '',
        placeId: '',
        classId: '',
        courseId: '',
        searchKey: '',
        beginExamTime: '',
        sessionId: '',
        minutes : ''
      },
      siteList: [],
      classList: [],
      courseList: [],
      isInspector: false,
      studentCountNumber: 0,
      placeName: '',
      className: '',
      courseObj: '',
      isCanExportJudge: false,
      ImportClassDialog: false,
      importForm: {
        planId: "",
        file: "",
      },
      downloadEntranceFlag : '0', // 是否显示准考证的按钮
      entranceCodeDialog: false,
      entranceRuleSetDialog: false,
      entranceRuleActiveTab: 'default',
      // 默认规则
      systemDefaultRules: [],
      // 自定义规则
      subjectList: [],
      generalRule: {
        customPrefix: '',
        numberLen: 4,
        numberStart: 1,
      },
      subjectRules: [],
      expandedSubjects: [],
      // 直接导入
      entranceImportFile: null,
      entranceImportData: [],
      entranceImportPagination: {
        total: 0,
        page: 1,
        size: 10,
      },
      entranceCodeForm: {
        entranceRule: 1,
        defaultRule: '',
        preCode: window.localStorage.getItem('tenant')?.toUpperCase() || '',
        rndNumber: 6,
        startNumber: ''
      }
    };
  },
  computed: {
    isShowFooter() {
      return this.showFooterPage.indexOf(this.$route.name) !== -1;
    },

    // 按钮控制
    mainTopBtnList() {
      let btnArr = [];
      if (this.planInfo.classPublish == 1 && this.isUseYy == 1) {
        btnArr = [
          {
            title: "下载鹰眼数据",
            fn: this.goDownSignActive,
          },
          {
            title: "下载OTS作答记录",
            fn: this.getAnswerRecord,
          }
        ];
      } else if (this.planInfo.classPublish == 0) {
        btnArr = [
          {
            title: "设置准考证号规则",
            fn: this.openEntranceRuleSetDialog,
            plain: true,
          },
          {
            title: "导入考场安排结果",
            fn: this.goImportClass,
            plain: true,
          },
          {
            title: "自动安排",
            fn: this.setClass,
            plain: true,
          },
          {
            title: "手动调整",
            fn: this.routerClass,
            plain: true,
          },
          {
            title: "一键发布",
            fn: this.publishClassDialog,
          },
        ];
      }
 

      return btnArr;
    },
    batchOperBtn(){
      const baseButtons = [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          }
        }
      ];
      const resultButtons = [
        {
          title: "导出考场安排结果",
          click: () => {
            this.exportAllStudentExcel();
          }
        }
      ];
      const entranceButtons = [
        {
          title: "批量导出准考证",
          click: () => {
            this.exportAllEntrance();
          }
        }
      ];
      if (this.pagination.total > 0) {
        if(this.downloadEntranceFlag == '1') {
          return [
            ...resultButtons,
            ...entranceButtons,
            ...baseButtons,
          ];
        }else{
          return [
            ...resultButtons,
            ...baseButtons,
          ];
        }

      }
      return baseButtons;
    }
  },
  created() {
    this.initData();
    this.getConfig();
    window.localStorage.setItem("paramslist", JSON.stringify());
  },
  watch: {
    "SuppleForm.placeId": function(val) {
      this.SuppleForm.classId = ""
      this.classList = [ {id: '', name: '全部'}, ...this.siteList.filter(
        (item) => item.id == val
      )[0].placeClassList ]
    },
    "SuppleForm": {
      handler(newVal) {
        this.isInspector = false
      },
      deep: true
    },
    "entranceRuleActiveTab": function(val) {
      if (val === 'import') {
        this.entranceImportPagination.page = 1;
        this.getEntranceImportDataList();
      }
    }
  },
  methods: {
    // 导入考场安排结果
    goImportClass() {
      this.ImportClassDialog = true;
    },

    // 执行导入考场安排结果
    rightImport() {
      this.importForm.planId = this.$route.query.id;
      if (!this.importForm.file) {
        this.$message.error("请选择文件！");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      importArrangeClassInfoAPI(fd).then(res=>{
        if (res.code) {
          this.ImportClassDialog = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount): 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          // let message = `导入完成，成功导入${successNum}条，失败${failNum}条`;
          let message = `导入完成，成功导入${successNum}条。`;
          let errMessage = `导入失败：存在${failNum}条不符合要求的数据，请修改后重新导入全部安排结果。`;
          
          this.$confirm(failNum > 0 ? errMessage: message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getClassList();
        }
      })
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    /**
     * @param { 点击批量补时 }
     */
    Click_Batch_Supple_Time(row) {
      this.SuppleInfo = {...row}
      this.getSuppleTimeData(row)
      for (let key in this.SuppleForm) {
        if (key != "sessionId" && key != "planId") {
          this.SuppleForm[key] = ''
        }
      }
      this.suppleTimeDialog = true
    },

    /**
     * @param { 获取补时下拉数据 }
     */
    async getSuppleTimeData(row){
      let { planId, id } = row
      this.SuppleForm.sessionId = id
      this.SuppleForm.planId = planId
      // 考点
      const { data: siteList} = await getPlanSite({ planId, sessionId: id })
      this.siteList = [{name: '全部', id: ''}, ...siteList]
      // 课程
      const { data: courseList } = await getCourseListBySessionList({sessionId: id})
      this.courseList = [{courseName: '全部', courseId: '', placeClassList: [] }, ...courseList]
      // 教室
      this.classList = [{id: '', name: '全部'}]
    },

    /**
     * @param { 核查人数 }
     */
    async inspectorNumber(){
      let Info = JSON.parse(JSON.stringify(this.SuppleForm))
      const { beginTime, endTime } = this.SuppleInfo
      const { beginExamTime, minutes } = Info

      if (!beginExamTime && !minutes) {
        this.$message.warning("请设置补时方案！")
        return
      }

      if (!beginExamTime) {
        this.$message.warning("请选择补时开始时间！")
        return
      }

      if (!minutes) {
        this.$message.warning("请输入补时数值！")
        return
      } else if (minutes<1 || minutes%1 != 0) {
        this.$message.warning("请输入正确的补时数值！")
        return        
      }

      let begin = Date.parse(new Date(beginTime).toString())
      let end = Date.parse(new Date(endTime).toString())
      let exam = Date.parse(new Date(beginExamTime).toString())
      if (exam < begin || exam > end) {
        this.$message.warning("请选择时间在考试有效期内！")
        return
      }

      const { data, code } = await addTimeStudentCountAPI(Info)
      if (code) {
        this.isInspector = true
        this.studentCountNumber = data
      }

      const { placeId, classId, courseId } = this.SuppleForm
      let placeObj = this.siteList.find(item=>{
        return item.id === placeId
      })
      let classObj = this.classList.find(item=>{
        return item.id === classId
      })
      let courseObj = this.courseList.find(item=>{
        return item.courseId === courseId
      })
      this.placeName = placeObj.name
      this.className = classObj.name
      this.courseName = courseObj.courseName
    },

    /**
     * @param { 执行补时操作 }
     */
    addSupple() {
      if (!this.isInspector) {
        this.$message.warning("请先核查人数范围！")
        return
      }

      if (this.studentCountNumber == 0) {
        this.$message.warning('未查询到可以补时的考生，您可以重新设置补时条件！')
        return
      }

      const h = this.$createElement
      this.$confirm('', "活动补时", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: h('p', null, [
          h('span', null, '确定将'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.SuppleForm.beginExamTime),
          h('span', null, '之前进入考试，正在答卷的'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.studentCountNumber),
          h('span', null, '名考生批量补时'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.SuppleForm.minutes),
          h('span', null, '分钟？'),
        ])
      }).then(async () => {
        let param = {...this.SuppleForm}
        const { code } = await addTimeBatchAPI(param)
        if (code == 1) this.$message.success('批量补时成功！')
        this.suppleTimeDialog = false
      })
    },

    // 下载 OTS 作答记录
    async getAnswerRecord() {
      const {code, data} = await downloadPreGeneratedAnswerPaperAPI({planId: this.classForm.planId});
      if (code == 1) {
        window.open(data);
      }
    },

    //下载活动安排
    goDownSignActive() {
      this.$api.system.exportUserArrangement({
        planId: this.$route.query.id,
      }).then((res) => {
        if (res.data) {
          window.open(res.data);
        }
      });
    },
    // 手动安排
    ManualSet() {
      this.$router.push({ name: "ManualSet" });
    },

    async initData() {
      let { data } = await getCurrentPlanFn({
        planId: this.$route.query.id,
      });
      this.planInfo = data;
      this.classForm.planId = this.planInfo.id;
      this.getClassList();
      this.downloadEntranceFlag = data.downloadEntrance;
      let result = await judgeImportArrangeClassInfoAPI({planId: this.$route.query.id})
      this.isCanExportJudge = result.data;

    },
    async getClassList() {
      const { data } = await getClassListFn(this.classForm);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
    changeSize(num) {
      this.classForm.size = num;
      this.getClassList();
    },
    changePage(p) {
      this.classForm.page = p;
      this.getClassList();
    },
    goDownSignTable() {
      this.$router.push({
        name: "signTable",
      });
    },
    async addSchool() {
      let setStudentClass = {
        planId: this.classForm.planId,
        courseFlag: this.courseFlag,
        classFlag: this.classFlag,
      }
      if (this.$route.query.planState == 4) {
        this.$confirm(
          "已做考场安排，再次安排会清除上一次安排数据，是否进行再次安排？",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(async () => {
          const { code } = await setStudentClassFn(setStudentClass);
          if (code == 1) {
            this.$message.success("安排成功");
            this.getClassList();
            this.addDialog = false;
          }
        });
      } else {
        const { code } = await setStudentClassFn(setStudentClass);
        if (code == 1) {
          this.$message.success("安排成功");
          this.getClassList();
          this.addDialog = false;
        }
      }
    },
    getConfig() {
      this.$api.system.getConfigData().then((res) => {
        let configList = res.data.configList;
        configList.forEach((item) => {
          if (item.setName == "needSignTable") {
            this.needSignTable = item.setValue == 1 ? true : false;
          }
          if (item.setName == "needMonitor") {
            this.isUseYy = item.setValue;
          }
          if (item.setName == "certificateRule") {
            this.entranceCodeForm.defaultRule = item.setValue2;
          }
        });
      });
    },

    /**
     * @param { 点击  一键发布  的时候弹出提示框，用于设置生成准考证的生成规则 }
     */
    publishClassDialog(){
      this.publishClass();
    },
    openEntranceRuleSetDialog() {
      this.entranceRuleSetDialog = true;
      this.entranceRuleActiveTab = 'default';
      this.entranceImportFile = null;
      this.entranceImportData = [];
      this.entranceImportPagination = { total: 0, page: 1, size: 10 };
      this.loadEntranceRuleData();
      this.getEntranceImportDataList();
    },
    async loadEntranceRuleData() {
      const planId = this.classForm.planId;
      // 并行请求
      const [defaultRes, customRes, subjectRes] = await Promise.all([
        getSystemDefaultRuleAPI(),
        getCustomRuleByPlanIdAPI({ planId }),
        getSubjectListByPlanIdAPI({ planId })
      ]);
      // 默认规则
      if (defaultRes.data) {
        this.systemDefaultRules = [
          { key: 'key1', value: defaultRes.data.key1 || '' },
          { key: 'key2', value: defaultRes.data.key2 || '' },
          { key: 'key3', value: defaultRes.data.key3 || '' },
        ];
      }
      // 专业列表
      this.subjectList = subjectRes.data || [];
      // 自定义规则
      this.subjectRules = [];
      this.generalRule = { customPrefix: '', numberLen: 4, numberStart: 1 };
      if (customRes.data && customRes.data.length > 0) {
        customRes.data.forEach(rule => {
          if (rule.generalFlag == 1) {
            this.generalRule = {
              customPrefix: rule.customPrefix || '',
              numberLen: rule.numberLen || 4,
              numberStart: rule.numberStart || 1,
            };
          } else if (rule.subjectId) {
            this.subjectRules.push({
              subjectId: rule.subjectId,
              customPrefix: rule.customPrefix || '',
              numberLen: rule.numberLen || 4,
              numberStart: rule.numberStart || 1,
            });
          }
        });
      }
      // 为没有规则的专业初始化默认规则
      this.subjectList.forEach(subject => {
        if (!this.subjectRules.find(r => r.subjectId == subject.id)) {
          this.subjectRules.push({
            subjectId: subject.id,
            customPrefix: '',
            numberLen: 4,
            numberStart: 1,
          });
        }
      });
      this.expandedSubjects = this.subjectList.map(s => s.id);
    },
    getSubjectRule(subjectId) {
      return this.subjectRules.find(r => r.subjectId == subjectId);
    },
    generateExample(rule) {
      if (!rule || !rule.customPrefix) return '--';
      const start = rule.numberStart || 1;
      const len = rule.numberLen || 4;
      const numStr = String(start).padStart(len, '0');
      return rule.customPrefix + numStr;
    },
    async saveEntranceRuleSet() {
      
      // 如果有任一专业填写了自定义前缀，则其他专业也必须填写
      const hasSubjectPrefix = this.subjectRules.some(r => r.customPrefix);
      if (hasSubjectPrefix) {
        const emptySubject = this.subjectRules.find(r => !r.customPrefix);
        if (emptySubject) {
          const subjectObj = this.subjectList.find(s => s.id == emptySubject.subjectId);
          this.$message.warning(`专业"${subjectObj ? subjectObj.name : ''}"未填写自定义前缀，填写了任一专业前缀后，其他专业也必须填写`);
          return;
        }
      }else{
        if (!this.generalRule.customPrefix) {
          this.$message.warning('请输入通用规则的自定义前缀');
          return;
        }
      }
      const planId = this.classForm.planId;
      // 拼接通用规则：prefix#numberLen#numberStart
      const generalRule = `${this.generalRule.customPrefix}#${this.generalRule.numberLen}#${this.generalRule.numberStart}`;
      // 拼接专业规则：prefix#numberLen#numberStart#subjectId,...
      const subjectParts = this.subjectRules
        .filter(r => r.customPrefix)
        .map(r => `${r.customPrefix}#${r.numberLen}#${r.numberStart}#${r.subjectId}`);
      const subjectRule = subjectParts.join(',');
      const params = { planId, generalRule, subjectRule };
      const { code } = await saveCustomRuleByPlanIdAPI(params);
      if (code == 1) {
        this.$message.success('保存成功！');
      }
    },
    async downloadEntranceTemplate() {
      const { code, data } = await entranceExportTemplateAPI({ planId: this.classForm.planId });
      if (code == 1 && data) {
        window.open(data);
      }
    },
    handleEntranceImportFile(val) {
      this.entranceImportFile = val.file;
    },
    async doEntranceImport() {
      if (!this.entranceImportFile) {
        this.$message.error('请选择文件！');
        return;
      }
      const fd = new FormData();
      fd.append('planId', this.classForm.planId);
      fd.append('file', this.entranceImportFile);
      const res = await entranceImportAPI(fd);
      if (res.code) {
        const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
        const totalNum = parseInt(res.data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}条。`;
        let errMessage = `导入失败：存在${failNum}条不符合要求的数据，请修改后重新导入。`;
        this.$confirm(failNum > 0 ? errMessage : message, '导入结果', {
          confirmButtonText: failNum > 0 ? '查看错误记录' : '确定',
          cancelButtonText: '取消',
          type: failNum > 0 ? 'warning' : 'success',
        }).then(() => {
          if (failNum > 0 && res.data.address) {
            window.open(res.data.address);
          }
        });
        this.getEntranceImportDataList();
      }
    },
    async getEntranceImportDataList() {
      const params = {
        planId: this.classForm.planId,
        page: this.entranceImportPagination.page,
        size: this.entranceImportPagination.size,
      };
      const { data } = await entranceImportDataListAPI(params);
      if (data) {
        this.entranceImportData = data.records || [];
        this.entranceImportPagination.total = data.total || 0;
      }
    },
    handleEntranceImportPageChange(page) {
      this.entranceImportPagination.page = page;
      this.getEntranceImportDataList();
    },
    entranceCodeDialogSubmit(){
      if(this.entranceCodeForm.entranceRule === 1){
        this.publishClass();
      }else{
        if(this.entranceCodeForm.preCode.replace(/\s*/g,"") === ''){
          this.$message.warning('请输入准考证号前缀');
          return;
        }
        if(this.entranceCodeForm.startNumber.replace(/\s*/g,"") === ''){
          this.$message.warning('请输入自定义流水起始号');
          return;
        }
        this.publishClass();
      }
    },
    /**
     * @param { 考场安排发布 }
     */
    async publishClass() {
      this.$confirm("确定要进行考场发布吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const params = {
          planId: this.classForm.planId,
        }
        const { code } = await publishPlanClassFn(params);
        if (code == 1) {
          this.$message.success("考场发布成功！");
          this.getClassList();
          // if (this.needSignTable) {
          //   openSignTable({ planId: this.classForm.planId });
          // }
          this.mixin_updateCurrentPlanInfo();
          // ** 考场发布接口调用成功后，调用生成桌贴接口
          // const exportClass = await exportClassRoom({planId: this.classForm.planId, typeId: 2});
          // ** 考场发布接口调用成功后，调用生成生成答卷的接口
          // const preAnswerPaper = await getPreGeneratedAnswerPaperAPI({planId: this.classForm.planId});
        }
      }).catch(() => {});
    },
    async setClass() {
      this.$confirm('自动安排会清除已安排的数据，包括手工调整的。是否要再次进行安排？',{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async()=>{
        this.addDialog = true;
      })
    },
    goHistory() {
      this.$router.push({
        name: "historyClass",
      });
    },
    routerClass() {
      this.$router.push({
        name: "manualAdjustment",
        query: {
          id: this.$route.query.id,
          name: this.planInfo.name,
        },
      });
    },
    checkStudent(row) {
      window.localStorage.setItem("checkPlan", JSON.stringify(row));
      this.$router.push({
        name: "student",
        query: {
          sessionId: row.id,
          planName: this.planInfo.name,
        },
      });
    },
    // 导出考场安排结果
    async exportAllStudentExcel() {
      let selfParam = {
        exportType : 1,
        planId : this.classForm.planId,
        sessionId : ""
      };
      const {code, data} = await exportStudentFn(selfParam);
      if (code == 1) {
        window.open(data);
      }
    },
    // 批量导出准考证
    async exportAllEntrance() {
      let selfParam = {
        planId : this.classForm.planId
      };
      const {code, data} = await exportEntranceFn(selfParam);
      if (code == 1) {
        this.$message.success(data);
      }
    },
    handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionEnd(event) {
      this.isComposing = false;
      this.processInput(event.target.value);
    },
    handlePreCodeInput(event) {
      if (!this.isComposing) {
        this.processInput(event.target.value);
      }
    },
    processInput(value) {
      value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      this.entranceCodeForm.preCode = value;
      event.target.value = value;
    }
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  margin-top: 0;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
}
.myFooter {
  width: 100%;
}
/deep/.el-switch {
  margin: 0 10px;
}
.classFlag {
  margin: 20px 0;
}
.courseFlag {
  margin: 20px 0;
}
.classFlagslass {
  margin: 20px 0;
}
.classFlagslass1 {
  margin: 30px 0 100px 0;
}
/deep/.dialog-footer {
  margin: 50px 0 !important;
}
.illustration{
  margin-left: 15px;
}

.msgBox {
  font-size: 14px;
  line-height: 2;
  color: #272e40;
  span {
    display: inline-block;
    width: 100px;
    color: #737780;
    margin-right: 10px;
  }
  .formStyle {
    width: 100%;
    height: auto;
    // background: rgba(0, 0, 0, .1);
    background: #F8F9FC;
    padding-top: 24px;
    padding-left: 16px;
    border-radius: 8px;
    .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 50%;
        height: 36px;
        display: flex;
        justify-content: left;
        margin-bottom: 16px;
        /deep/ .el-form-item__label {
          line-height: 36px;
          text-align: right;
        }
        /deep/ .el-form-item__content{
          margin: 0!important;
        }
        /deep/ .el-input .el-input__inner {
            width: 240px;
            height: 36px;
            line-height: 18px;
        }
        /deep/ .el-form-item__content {
          width: 240px;
          .el-input {
            width:240px;
          }
        }
        .el-select {
          width: 240px;
          /deep/ .el-input.el-input--suffix {
            width: 100%;
          }
          /deep/ .el-input__inner {
            width: 240px;
          }
        }

      }
    }

  }
}

.check {
  margin: 16px 0;
}
/deep/.numrule input::-webkit-outer-spin-button,
/deep/.numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
}

// 准考证号自定义规则弹窗
#pane-default {
  margin: auto; padding:2% 20%; 
}
.default-rule-list {
  display: flex;
  gap: 5px;
  margin-top: 20px;
}
.default-rule-item {
  width: 32%;
  padding: 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #e9ebf0;
  word-break: break-all;
  letter-spacing: 1px;
  text-align: center;
}
.bg-blue { background: #125283; }
.bg-orange { background: #e3a061; }
.bg-green { background: #54d384; }
.default-rule-remark {
  margin-top: 16px;
  font-size: 13px;
  color: #737780;
}
.custom-section {
  margin-top: 16px;
}
.custom-section-title {
  margin-bottom: 12px;
  color: #272e40;
}
.custom-fieldset {
  border: 2px solid #dcdfe6;
  border-radius: 16px;
  padding: 16px 20px 8px;
  margin-bottom: 16px;
}
.custom-legend {
  font-size: 14px;
  font-weight: 600;
  color: #272e40;
  padding: 0 8px;
  margin-left: 12px;
}
.custom-rule-form {
  .el-form-item {
    margin-bottom: 8px;
  }
}
.rule-example {
  color: #409EFF;
  font-size: 13px;
}
.subject-title {
  font-weight: 500;
}
.subject-example {
  margin-left: 16px;
  color: #409EFF;
  font-size: 13px;
}
.import-section {
  margin-top: 16px;
}
.import-row {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.import-label {
  color: #737780;
  margin-right: 8px;
}

/deep/.el-form-item__label{
  line-height: 32px;
}
/deep/.el-input{
  width: 160px;
}
/deep/.el-input__inner{
  width: 160px;
  padding: 8px 8px 8px 12px !important;
}
/deep/.el-collapse-item__header{
  border: 0px ;
  background-color: #f1f5f3 !important;
  padding-left: 20px !important;
  padding-right: 10px !important;
  margin-bottom: 5px !important;
  height: 30px ;
  line-height: 30px ;
}
/deep/.el-collapse-item__wrap{
  border: 0px ;
}

</style>
